import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, unref as _unref, resolveComponent as _resolveComponent, withCtx as _withCtx, withModifiers as _withModifiers, openBlock as _openBlock, createBlock as _createBlock, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/theme/imgs/logo_completo.svg'

const _withId = /*#__PURE__*/_withScopeId("data-v-92b68dae")

_pushScopeId("data-v-92b68dae")
const _hoisted_1 = { class: "login-container" }
const _hoisted_2 = { class: "main-container" }
const _hoisted_3 = /*#__PURE__*/_createVNode("img", {
  class: "smash-img",
  src: _imports_0,
  alt: ""
}, null, -1)
const _hoisted_4 = { class: "access-wesmash-text color-white font-size barlow" }
const _hoisted_5 = /*#__PURE__*/_createTextVNode(" Benvenuto ")
const _hoisted_6 = { class: "p-text-bold" }
const _hoisted_7 = /*#__PURE__*/_createTextVNode(".")
const _hoisted_8 = /*#__PURE__*/_createVNode("br", null, null, -1)
const _hoisted_9 = /*#__PURE__*/_createTextVNode("Imposta la tua password per accedere a WeSmash Backoffice. ")
const _hoisted_10 = { class: "form-container" }
const _hoisted_11 = { class: "p-fluid" }
_popScopeId()

import { client } from '@/api/client-v2';
import UiButton from '@/components/ui/UiButton.vue';
import { showSuccessToast, showToast } from '@/services/error-management.service';
import { onMounted, ref } from 'vue';
import { useI18n } from 'vue-i18n';
import { useRoute, useRouter } from 'vue-router';
import { object, string, ref as yupRef } from 'yup';


export default _defineComponent({
  setup(__props) {

const { t } = useI18n();
const route = useRoute();
const router = useRouter();

const email = ref('');

const password = ref('');
const passwordConfirmation = ref('');
const loading = ref(false);

const errors = ref({
    password: '',
    passwordConfirmation: ''
});

const schema = object({
    password: string()
        .required(t('required_field'))
        .min(12, t('password_min_length'))
        .matches(/(?=.*\d)(?=.*[a-z])(?=.*[A-Z])(?=.*\W)/, t('password_not_valid')),
    passwordConfirmation: string()
        .required(t('required_field'))
        .oneOf([yupRef('password')], t('passwords_dont_match')),
});

const validate = async () => {
    try {
        await schema.validate({
            password: password.value,
            passwordConfirmation: passwordConfirmation.value
        }, { abortEarly: false });
        errors.value = { password: '', passwordConfirmation: '' };
        return true;
    } catch (err: any) {
        errors.value = { password: '', passwordConfirmation: '' };
        err.inner.forEach((error: any) => {
            if (error.path === 'password') errors.value.password = error.message;
            if (error.path === 'passwordConfirmation') errors.value.passwordConfirmation = error.message;
        });
        return false;
    }
}

const confirmRegistration = async () => {
    const isValid = await validate();
    if (!isValid) return;

    try {
        loading.value = true;
        await client.confirmManagerRegistration({
            token: route.query.token as string,
            password: password.value,
            confirmPassword: passwordConfirmation.value,
            privacyAccepted: true
        })
        showSuccessToast('Password impostata con successo! Ora puoi accedere al backoffice.');
        router.push({ name: 'PadelLogin' });
    } catch {
        showToast('Si è verificato un errore durante l\'impostazione della password. Riprova più tardi.');
    } finally {
        loading.value = false;
    }
}

onMounted(() => {
    email.value = route.query.email as string || '';
});

return (_ctx: any,_cache: any) => {
  const _component_PadelInput = _resolveComponent("PadelInput")!

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode("div", _hoisted_2, [
      _hoisted_3,
      _createVNode("div", _hoisted_4, [
        _hoisted_5,
        _createVNode("strong", _hoisted_6, _toDisplayString(email.value), 1),
        _hoisted_7,
        _hoisted_8,
        _hoisted_9
      ]),
      _createVNode("div", _hoisted_10, [
        _createVNode("div", _hoisted_11, [
          _createVNode("form", {
            class: "p-d-flex p-flex-column gap-20",
            onSubmit: _withModifiers(confirmRegistration, ["prevent"])
          }, [
            _createVNode(_component_PadelInput, {
              placeholder: _unref(t)('password'),
              "input-type": "password",
              label: _unref(t)('password'),
              value: password.value,
              "onUpdate:value": _cache[1] || (_cache[1] = ($event: any) => (password.value = $event)),
              error: errors.value.password
            }, null, 8, ["placeholder", "label", "value", "error"]),
            _createVNode(_component_PadelInput, {
              placeholder: _unref(t)('passwordConfirmation'),
              "input-type": "password",
              label: _unref(t)('passwordConfirmation'),
              value: passwordConfirmation.value,
              "onUpdate:value": _cache[2] || (_cache[2] = ($event: any) => (passwordConfirmation.value = $event)),
              error: errors.value.passwordConfirmation
            }, null, 8, ["placeholder", "label", "value", "error"]),
            _createVNode(UiButton, {
              disabled: loading.value,
              type: "submit",
              size: "lg"
            }, {
              default: _withId(() => [
                _createTextVNode(_toDisplayString(_unref(t)('setPassword')), 1)
              ]),
              _: 1
            }, 8, ["disabled"])
          ], 40, ["onSubmit"])
        ])
      ])
    ])
  ]))
}
}

})